import type { IBreakpoint } from '~~/types/local_types';

export const breakpoints: IBreakpoint[] = [
  { name: 'sm', min: 0, max: 639 },
  { name: 'md', min: 640, max: 1023 },
  { name: 'lg', min: 1024, max: 1279 },
  { name: 'xl', min: 1280, max: 1439 },
  { name: 'xxl', min: 1440 },
];
